// Entry point for the build script in package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "./channels";
import { initAnalytics } from "./utils/analytics";
import "./notifications";
import "./push_notifications";

document.addEventListener('turbo:load', () => {
  initAnalytics();
});

